import { useCallback, useState } from 'react'

import useCallbackRef from 'app/common/hooks/useCallbackRef'
import { ActionButtonWithConfirm } from './ActionButtonWithConfirm'
import { ActionButtonWithPrompt } from './ActionButtonWithPrompt'
import { EncashmentsStatusType } from 'app/dataTypes/reports/data'
import { StopPropagation } from 'app/common/ui-components/table'
import SimpleDate from 'app/common/classes/simple-date'
import styles from './Action.module.scss'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link/plain-button-as-link'
import {
  EncashmentsAction,
  EncashmentsStatusAction,
} from 'app/dataTypes/reports/data/finances/encashments/action'

type Props = {
  status: EncashmentsStatusType | null
  date: SimpleDate
  salePointId: string
  salePointTitle: string
  schoolTitle: string
  onChangeStatus: (params: EncashmentsStatusAction) => Promise<boolean>
}

export const Action = ({
  status,
  date,
  salePointId,
  salePointTitle,
  schoolTitle,
  onChangeStatus,
}: Props) => {
  const [disabled, setDisabled] = useState<boolean>(false)

  const onChangeStatusRef = useCallbackRef(onChangeStatus)
  const handleAccept = useCallback(async () => {
    setDisabled(true)
    const res = await onChangeStatusRef.current?.({
      salePointId,
      date,
      action: EncashmentsAction.Accept,
    })
    setDisabled(false)
    return !!res
  }, [salePointId, date, onChangeStatusRef])

  const handleReject = useCallback(
    async (comment: string) => {
      setDisabled(true)
      const res = await onChangeStatusRef.current?.({
        salePointId,
        date,
        action: EncashmentsAction.Reject,
        comment,
      })
      setDisabled(false)
      return !!res
    },
    [salePointId, date, onChangeStatusRef],
  )

  return (
    <StopPropagation className={styles.root}>
      {status === EncashmentsStatusType.WaitingForCash && (
        <ActionButtonWithConfirm
          title="Подтвердить"
          confirmText={`Подтвердить принятие наличных для точки продажи — ${salePointTitle} (${schoolTitle})?`}
          onConfirm={handleAccept}
        />
      )}

      {status === EncashmentsStatusType.WaitingForCash && (
        <ActionButtonWithPrompt
          title="Отказать"
          confirmText={`Введите причину отказа для точки продажи — ${salePointTitle} (${schoolTitle})`}
          onConfirm={handleReject}
        >
          {(toggle) => (
            <PlainButtonAsLink
              onClick={toggle}
              disabled={disabled}
              linkClassName={styles.rejectBtn}
              type="button"
            >
              {disabled ? 'обработка...' : 'Отказать'}
            </PlainButtonAsLink>
          )}
        </ActionButtonWithPrompt>
      )}
    </StopPropagation>
  )
}
